import { CommonAPIService } from "@/serviceHandlers/CommonHandler";

export default class SitesAPIService {
  constructor() {
    this.commonAPIservice = new CommonAPIService();
  }

  getSiteInfo(siteId, router) {
    const url = `/api/sites/${siteId}`;
    return this.commonAPIservice.getCall(url, "", router);
  }

  getSites(router) {
    const url = "/api/sites";
    return this.commonAPIservice.getCall(url, "", router);
  }

  createSite(params, router) {
    const url = "/api/sites";
    return this.commonAPIservice.postCall(url, params, router);
  }

  updateSite(siteId, params, router) {
    const url = `/api/sites/${siteId}`;
    return this.commonAPIservice.putCall(url, params, router);
  }

  deleteSite(siteId, router) {
    const url = `/api/sites/${siteId}`;
    return this.commonAPIservice.deleteCall(url, "", router);
  }

  addClientToSite(siteId, clientId, router) {
    const url = `/api/sites/${siteId}/clients`;
    const params = { clientId };
    return this.commonAPIservice.postCall(url, params, router);
  }

  removeClientFromSite(siteId, clientId, router) {
    const url = `/api/sites/${siteId}/clients/${clientId}`;
    return this.commonAPIservice.deleteCall(url, "", router);
  }
}
